// import { IndirectEval } from "./indirectEval";
//import { useSelector, useDispatch } from "react-redux";
const IndirectEval = (evalString) =>{
    // const selectedData = useSelector((state)=>state.formData.selectedData)
        return eval(evalString)
}
export const calculateNetAssets=(fieldValues)=>{
    return fieldValues && Object.keys(fieldValues).reduce((total, field) => {
        // // console.log(total,field);
        return IndirectEval(`${total || 0} ${fieldValues[field].operator} ${fieldValues[field]?.value || 0}`);
    },0)
 }
 export const matchDetails=(key,value,arr)=>{
  let matchedValue
  arr.map((item,index)=>{
    if(item[key]==value){
      matchedValue = item
    }
  })
  return matchedValue
 }

 export const compareData = (value_1,value_2,arr)=>{
    let count,flag=0;
      arr.map((item, index) => {
        count =0
        for(let i in item){
          if(item[i]==value_1 ||item[i]==value_2) {
            count +=1
          } 
          if(count==2){
            flag = 1
            break;
          }     
         }
      });
      if(flag==0)
      {return false}
      else if(flag==1)
      {return true}
      
 }
 export const CheckForIndianResident =(arr,data,val)=>{
  let isEqual =false
  arr?.forEach((item,index)=>{
    if(item.residence_country =='India'){
      isEqual = true
    }
  })
  return isEqual

 }

 export const calculateGrade = (score,evaluationRule) =>  {
  let values;
  let grade;
  let newArr;
  let index;
  let res = getResult(score);
  function getResult(score) {
    grade = Object.keys(evaluationRule)
    values = Object.values(evaluationRule)
    if(score) {
      if(values?.includes(score)){
        index = values.indexOf(score);
        return grade[index]
      } else {
        newArr = values.concat(score)
        newArr.sort((a,b) => a-b)
        index = newArr.indexOf(score)
      }
    }
    if(index >= grade.length){
      return grade[index-1]
    } else if(index == 0){
      return grade[index];
    } else return grade[index]
  }
  return ({ grade: res });
}

 export const calculateGrandTotal = async (add, subtract, netField, totalField,data ,dispatch, assignValueToKey,multiply) => {
  let result, res = 0.0;
  let output = 0.0;
  add.forEach((key) => {
    if (!data[key]) return;
    let field_value = data[key].split(",").join("")
    res += parseFloat(field_value);
    result=res.toFixed(2);
    output = result.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')  
  });
  if (totalField && result) {dispatch(assignValueToKey({ key: totalField, value: output }))}
  else if (totalField && result === undefined)   dispatch(assignValueToKey({ key: totalField, value: 0 }))
  subtract.forEach((key) => {
    if (!data[key]) return;
    let field_value = data[key].split(",").join("")
    res -= parseFloat(field_value);
    result=res.toFixed(2)
    output= result.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')  
  });
  if(multiply){
    res = 1
    multiply.forEach((key) => {
      if (!data[key]) return;
      let field_value = data[key].split(",").join("")
      res *= parseFloat(field_value);
      result=res.toFixed(2)
      output= result.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')  
    });
  }
  if (netField) 
  dispatch(assignValueToKey({ key: netField, value: output }));
  }  ;

  export const generateCurrency = (value,currency_type) => {
    //curreny variable added
    if(currency_type === "USD"){
      let val;
      let floatValue;
      if(value?.includes(".")){
        floatValue = value?.split(".");
        val = floatValue[0]?.split("").reverse().join("");
      } else val = value?.split("").reverse().join("");
      let new_str = "";
      for(let i=0;i<val?.length;i++){
          if((i+1)%3==0 && (i+1)<val.length){
              new_str += val[i];
              new_str += ",";
          } else {
              new_str += val[i];
          }
      }
      new_str = new_str.split("").reverse().join("");
      if(value?.includes(".")){
        new_str = new_str + "." + floatValue[1];
      }
      return new_str;
    }
    else if(currency_type === "INR"){
      let val;
      let floatValue;
      if(value?.includes(".")){
        floatValue = value?.split(".");
        val = floatValue[0]?.split("").reverse().join("");
      } else val = value?.split("").reverse().join("");
      if((floatValue ? floatValue[0]?.length > 3 : value?.length > 3)){
        let end = val?.slice(0,3);
        val = val?.slice(3);
        let new_str = "";
        for(let i=0;i<val?.length;i++){
            if((i+1)%2==0 && (i+1)<val.length){
                new_str += val[i];
                new_str += ",";
            } else {
                new_str += val[i];
            }
        }
        new_str = new_str.split("").reverse().join("");
        end = end?.split("").reverse().join("");
        new_str += `,${end}`;
        if(value?.includes(".")){
          new_str = new_str + "." + floatValue[1];
        }
        return new_str;
      } else return value;
    }
  }
 
 